import { useEffect, useState } from "react";
import { Chains } from "./data";
import { useAppSelector } from "../app/hooks";
import { selectChain } from "../features/chain";
export type ChainSelectorType = {};

const ChainSelector = (): JSX.Element => {
  const [openList, setOpenList] = useState(false);
  const chain = useAppSelector(selectChain);

  function toggleList() {
    setOpenList(!openList);
  }
  useEffect(() => {
    document.addEventListener("click", (e) => {
      setOpenList(false);
    });
  }, []);
  return (
    <>
      {openList && (
        <div className="relative text-white p-1 py-2 md:p-2">
          <div className="absolute right-0 top-full bg-[#595959] p-1 py-2 md:p-2 rounded-xl ">
            <ul className="text-white flex flex-col gap-1 md:gap-2">
              <li>
                <button
                  className="flex items-center gap-1 md:gap-2"
                  onClick={(e) => {
                    toggleList();
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                >
                  <img
                    className="w-6 md:w-7 h-6 md:h-7"
                    src={Chains[chain].chainIcon}
                    alt=""
                  />
                  <span className="text-sm md:text-lg">
                    {Chains[chain].chainName}
                  </span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
      {!openList && (
        <div className="text-white p-1 py-2 md:p-2">
          <button
            className="flex items-center gap-1 md:gap-2"
            onClick={(e) => {
              //   toggleList();
              e.nativeEvent.stopImmediatePropagation();
            }}
          >
            <img
              className="w-6 md:w-7 h-6 md:h-7"
              src={Chains[chain].chainIcon}
              alt=""
            />
            <span className="text-sm md:text-lg">
              {Chains[chain].chainName}
            </span>
          </button>
        </div>
      )}
    </>
  );
};

export default ChainSelector;
